enum TemplateType {
  STANDARD,
  CONTINGENCY,
}

export default TemplateType;
